<div class="notification-panel">
  <motif-modal-title>
    <div class="motif-row notificationHeaderContainer">
      <motif-icon
        size="30"
        class="motif-icon"
        [iconFunction]="bellIcon"
      ></motif-icon>
      <div class="header-text">
        <h2 class="header-title">{{ "Notifications" | translate }}</h2>
      </div>
    </div>
    <button
      motifIconButton
      aria-label="Close modal"
      [motif-modal-close]="true"
      [size]="buttonSizes.SMALL"
    >
      <motif-icon
        class="motif-modal-header-close-icon"
        size="24"
        [iconFunction]="closeIcon"
      ></motif-icon>
    </button>
  </motif-modal-title>

  <motif-modal-content>
    <div class="motif-row">
      <div class="motif-col-xs-10 notification-controls-row">
        <div class="toggle-switch">
          <motif-toggle-switch
            name="Default Off Switch"
            prelabel="{{ 'All' | translate }}"
            [(ngModel)]="unreadonly"
            postlabel="{{ 'UnreadOnly' | translate }}"
            (change)="fetchUnreadNotifications()"
          ></motif-toggle-switch>
        </div>
        <div *ngIf="(notifications$ | async)?.length > 0">
          <button
            motifIconButton
            aria-label="Delete all"
            [motif-tooltip]="'DeleteAllNotifications' | translate"
            [size]="buttonSizes.SMALL"
            (click)="deleteAllNotifications()"
          >
            <motif-icon size="20" [iconFunction]="closeIcon"></motif-icon>
          </button>
          <button
            motifIconButton
            aria-label="Mark all read"
            [motif-tooltip]="'MarkAllAsRead' | translate"
            [size]="buttonSizes.SMALL"
            (click)="markAllRead()"
          >
            <motif-icon size="20" [iconFunction]="readIcon"></motif-icon>
          </button>
        </div>
      </div>
    </div>
    <div
      *ngIf="(notifications$ | async)?.length === 0"
      class="no-notification motif-row"
    >
      <div class="notification-image-area"></div>
      <div class="nonotification-message-area">
        {{
          unreadonly
            ? ("No-NewNotifications" | translate)
            : ("No-Notifications" | translate)
        }}
      </div>
    </div>
    <div *ngIf="(notifications$ | async)?.length > 0" class="notification-list">
      <div
        *ngFor="
          let notification of notifications$ | async;
          trackBy: trackByNotificationId
        "
      >
        <app-general-mention
          [notification]="notification"
        ></app-general-mention>
      </div>
      <div
        class="motif-row load-more-container"
        *ngIf="
          (notifications$ | async)?.length > 0 &&
          (notifications$ | async)?.length < (totalCount$ | async)
        "
      >
        <div class="motif-col-xs-12">
          <a
            (click)="loadMore($event)"
            motifTextLink
            [isDisabled]="false"
            color="primary-alt"
            >Load More</a
          >
        </div>
      </div>
    </div>
  </motif-modal-content>
</div>
